/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import Modal from './index';
import style from './modal.module.scss';
import Button from 'controls/buttons/submit';
import cx from 'classnames';

export default function WarningModal({
  mainText,
  detailedText,
  buttonText,
  onCancel,
  onConfirm,
  onConfirmLoader,
}: {
  mainText: string;
  detailedText: string;
  buttonText: string;
  onCancel: () => void;
  onConfirm: () => void;
  onConfirmLoader?: boolean;
}) {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Modal open={true} onClose={onCancel}>
      <div className={style.warning}>
        <span className={style.mainText}>{mainText}</span>
        <span className={style.detailedText}>{detailedText}</span>
        <div className={style.buttons}>
          <Button
            className={style.close}
            onClick={() => {
              onConfirm();

              if (onConfirmLoader) {
                setIsLoading(true);
              }
            }}
            wrapper={{
              loading: isLoading,
            }}
          >
            {!isLoading && buttonText}
          </Button>
          <Button className={cx(style.close, 'btn-cancel')} onClick={onCancel}>
            Отмена
          </Button>
        </div>
      </div>
    </Modal>
  );
}
